<!-- Export Certificate Management -->
<div class="d-flex flex-column flex-column-fluid">
  <!-- Export Certificate Listing Component -->
  <app-export-certificate-listing #certificateListing>
  </app-export-certificate-listing>
</div>

<!-- Export Certificate Add/Edit Modal -->
<app-vh-manager-export-certificate
  (certificateAdded)="onCertificateAdded()"
  (certificateUpdated)="onCertificateUpdated()">
</app-vh-manager-export-certificate>

<!-- View Export Certificate Modal -->
<app-view-export-certificate></app-view-export-certificate>
